import { NgModule } from "@angular/core";
import { BHQrCodeScannerFormComponent } from './bh-qrcode-scanner-form/bh-qrcode-scanner-form.component';
import { DynamicBHQrCodeScannerComponent } from './dynamic-bh-qrcode-scanner.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { BHQrCodeScannerDesignComponent } from './bh-qrcode-scanner-design/bh-qrcode-scanner-design.component';
import { BHQrCodeScannerResultComponent } from './bh-qrcode-scanner-result/bh-qrcode-scanner-result.component';
import { BHQrCodeScannerService } from './bh-qrcode-scanner.service';
import { KendoModule } from '../../kendo.module';
import { MaterialModule } from 'src/app/shared/material.module';

@NgModule({
    declarations: [
        BHQrCodeScannerResultComponent,
        BHQrCodeScannerDesignComponent,
        BHQrCodeScannerFormComponent, DynamicBHQrCodeScannerComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        KendoModule,
        MaterialModule,
    ],
    providers: [
        BHQrCodeScannerService
    ],
    exports: [
        BHQrCodeScannerFormComponent
    ],
    entryComponents: [
        DynamicBHQrCodeScannerComponent
    ]
})
export class BHQrCodeScannerModule {}